// /src/components/Banner.js
import React from 'react';

function Banner() {
  return (
    <div className="relative w-screen p-2 mb-5 bg-/80 box-border shadow-glow overflow-hidden">
      <div className="whitespace-nowrap animate-marquee text-monadWhite text-lg font-bold hover-pause">
			  {/* <img
				src="https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_1.png"
				alt="Sealuminati Logo"
				className="inline-block h-8 w-auto mr-2"
			  />
			  Sponsored by:
			  <a
				href="https://x.com/sealuminati"
				target="_blank"
				rel="noopener noreferrer"
				className="inline-block -ml-8"
			  >
				<img
				  src="https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati-removebg-preview.png"
				  alt="Sealuminati Logo"
				  className="inline-block h-11 w-auto"
				/>
				<img
				  src="https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/sealuminati_1.png"
				  alt="Sealuminati Logo"
				  className="inline-block h-8 w-auto -ml-8"
				/>
			  </a> */}
      </div>
      <style jsx>{`
        .hover-pause:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}

export default Banner;
